import styled from 'styled-components';

export const NutritiveSolution = styled.div`
  background: white;
  min-height: 100%;
`
